import { createContext, type MutableRefObject } from 'react'

/**
 * A guard consulted before an in-app nav-bar navigation runs. It receives the intended destination
 * path and returns `true` when it has handled/blocked the navigation (the caller then calls
 * `preventDefault()` so React Router's NavLink does not navigate). Returns `false` to allow it.
 */
export type NavigationGuard = (destination: string) => boolean

export type NavigationGuardContextValue = {
  guardRef: MutableRefObject<NavigationGuard | null>
}

export const NavigationGuardContext = createContext<NavigationGuardContextValue | null>(null)
